// check if add-on service is monthly warranty
// read the metafield 'custom.warranty_code'
// send to API to get the warranty details

//example response
// {
//     "warranty_retail_price": 5.2,
//     "appliance_name": "American Fridge Freezer",
//     "retail_price_ceiling": 500,
//     "product_name": "Pacifica_Monthly_Warranty_M1"
// }


function getWarrantyDetails(applianceValue, warrantyCode) {
    return fetch(`https://pricingapp-production.up.railway.app/warranties?applianceValue=${applianceValue}&shortCode=${warrantyCode}`)
           .then(response => response.json());
}


